import React from "react";
import { motion } from "framer-motion";
import { socialLinks } from "../../data/commonData";
import {
  TwitterIcon,
  GithubIcon,
  InstagramIcon,
  LinkedInIcon,
} from "./SocialIcons";

// Map icon string to actual component
const iconMap = {
  TwitterIcon,
  GithubIcon,
  InstagramIcon,
  LinkedInIcon,
};

const Footer = () => {
  return (
    <footer
      className="dark:bg-[#121212] text-gray-600 dark:text-gray-400 pt-10 pb-6 w-full transition-colors duration-300"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-8">
        <section className="w-full flex flex-col md:flex-row items-center justify-between gap-6 md:gap-0 py-2">
          <div className="text-base font-semibold text-zinc-700 dark:text-zinc-300 tracking-tight">
            Omkar Khoche
          </div>
          <div className="flex flex-row gap-4">
            {socialLinks.map((link, index) => {
              const Icon = iconMap[link.icon];
              return (
                <motion.a
                  key={index}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-all duration-200 hover:-translate-y-1 p-2"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  aria-label={link.label}
                >
                  <Icon className="w-5 h-5" />
                </motion.a>
              );
            })}
          </div>
        </section>
      </div>
    </footer>
  );
};

export default Footer;